import { HelprerContentItem } from "../../../../types/propsTypes";

export const guideHelpers = {
    pageTitle: [
        {
            type: 'title',
            text: 'Справочник'
        },
        'Отображается на странице с информацией. Содержит редактируюмую справочную информацию.'
    ] as HelprerContentItem[]
}